import React from 'react';

import { Box, Button, Dialog, H2, Separator, Text } from '@betterment/samba-react';

export const PerformanceDisclosureDialog: React.FC = () => {
  return (
    <Dialog overlay="default">
      <Dialog.Trigger data-samba-component={true} asChild={true}>
        <Button variant="textSecondary">disclosure</Button>
      </Dialog.Trigger>
      <Dialog.Content
        css={{
          padding: 'space.400',
          width: '100%',
          maxWidth: 'container.xlarge',
          maxHeight: '80vh',
          overflow: 'auto',
        }}
      >
        <Dialog.Title asChild={true}>
          <H2 variant="pageTitle">Data types and refresh rate</H2>
        </Dialog.Title>

        <Separator css={{ marginY: 'space.200' }} />

        <Box
          css={{
            marginY: 'space.200',
          }}
        >
          <Text>
            Pricing and additional investment information obtained from FactSet is refreshed per the following schedule,
            subject to unexpected outages:
          </Text>
        </Box>

        <Separator css={{ marginY: 'space.200' }} />

        <Box
          css={{
            marginY: 'space.200',
          }}
        >
          <Text as="p">Your holdings and Details sections</Text>
          <Text as="span" color="text.weak" variant="text50">
            Every 16 minutes
          </Text>
        </Box>

        <Separator css={{ marginY: 'space.200' }} />

        <Box
          css={{
            marginY: 'space.200',
          }}
        >
          <Text as="p">About section</Text>
          <Text as="span" color="text.weak" variant="text50">
            Every 24 hours
          </Text>
        </Box>

        <Separator css={{ marginY: 'space.200' }} />

        <Box
          css={{
            marginY: 'space.200',
          }}
        >
          <Text as="p">Top holdings section</Text>
          <Text as="span" color="text.weak" variant="text50">
            Per fund rebalance schedule
          </Text>
        </Box>

        <Separator css={{ marginY: 'space.200' }} />

        <Box
          css={{
            marginY: 'space.200',
          }}
        >
          <Text as="p">Description</Text>
          <Text as="span" color="text.weak" variant="text50">
            At provider discretion
          </Text>
        </Box>

        <Box css={{ marginTop: 'space.400' }}>
          <Dialog.Close asChild={true}>
            <Button variant="solidSecondary" css={{ display: 'inline' }}>
              Close
            </Button>
          </Dialog.Close>
        </Box>
      </Dialog.Content>
    </Dialog>
  );
};
